import axios from 'axios';
import config from '@assets/config.json'; // api 请求json 

const state = {
}
const mutations = {
}
const getters = {
}
const actions = {
    getAuditList({ rootState }, opt) { // 获取审核列表
        return new Promise((resolve, reject) => {
            axios.post(`${config.api.reqApi}/api/Audit/GetAuditList`, opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    }, 
    setOneStepAudit({ rootState }, opt) { // 一键审核
        return new Promise((resolve, reject) => {
            axios.post(`${config.api.reqApi}/api/Audit/Audit`, opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },  
    reSync({ rootState }, opt) { // 重新同步信息
        return new Promise((resolve, reject) => {
            axios.post(`${config.api.reqApi}/api/Audit/ReSync`, opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },  

    getCompanyDownById({ rootState }, id) { // 获取公司down表 修改记录
        return new Promise((resolve, reject) => {
            axios.get(`${config.api.reqApi}/api/CompanyDown?id=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    getCompanyDownByRecord({ rootState }, id) { // 获取公司down表 修改记录
        return new Promise((resolve, reject) => {
            axios.get(`${config.api.reqApi}/api/CompanyDown/GetRecord?joinId=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    }, 
    editAudit({ rootState }, opt) { // 修改公司审核状态
        return new Promise((resolve, reject) => {
            axios.put(`${config.api.reqApi}/api/CompanyDown/Verify`, opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err.response.data);
            });
        });
    }, 

    getHasAuditInfos({ rootState }, id) { // 获取会刊down表 修改记录 
        // 对应关系（1：公司信息、2：联系人信息、3：会刊信息、4：开票信息、5：楣板信息、6：订单信息、7：车证信息、8：修改密码）
        return new Promise((resolve, reject) => {
            axios.get(`${config.api.reqApi}/api/Audit/GetHasAuditInfos?joinId=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    getCatalogueDownById({ rootState }, id) { // 获取会刊down表 修改记录
        return new Promise((resolve, reject) => {
            axios.get(`${config.api.reqApi}/api/CatalogueDown?id=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    getCatalogueDownByRecord({ rootState }, id) { // 获取会刊down表 修改记录
        return new Promise((resolve, reject) => {
            axios.get(`${config.api.reqApi}/api/CatalogueDown/GetRecord?joinId=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    }, 
    editCatalogueAudit({ rootState },opt) { // 修改会刊审核状态
        return new Promise((resolve, reject) => {
            axios.put(`${config.api.reqApi}/api/CatalogueDown/Verify?joinId=${opt.id}`, opt.opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err.response.data);
            });
        });
    }, 

    getInvoiceDownById({ rootState }, id) { // 获取开票down表 修改记录
        return new Promise((resolve, reject) => {
            axios.get(`${config.api.reqApi}/api/InvoiceDown?id=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    getInvoiceDownByRecord({ rootState }, id) { // 获取开票down表 修改记录
        return new Promise((resolve, reject) => {
            axios.get(`${config.api.reqApi}/api/InvoiceDown/GetRecord?joinId=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    }, 
    editInvoiceAudit({ rootState }, opt) { // 修改开票审核状态
        return new Promise((resolve, reject) => {
            axios.put(`${config.api.reqApi}/api/InvoiceDown/Verify`, opt.opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err.response.data);
            });
        });
    }, 

    getContactDownById({ rootState }, id) { // 获取开票down表 修改记录
        return new Promise((resolve, reject) => {
            axios.get(`${config.api.reqApi}/api/ContactDown?id=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    getContactDownByRecord({ rootState }, id) { // 获取开票down表 修改记录
        return new Promise((resolve, reject) => {
            axios.get(`${config.api.reqApi}/api/ContactDown/GetRecord?joinId=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    }, 
    editContactDownAudit({ rootState }, opt) { // 修改开票审核状态
        return new Promise((resolve, reject) => {
            axios.put(`${config.api.reqApi}/api/ContactDown/Verify`, opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err.response.data);
            });
        });
    },   
 

    getLintelDownById({ rootState }, id) { // 获取楣板own表 修改记录
        return new Promise((resolve, reject) => {
            axios.get(`${config.api.reqApi}/api/LintelDown?id=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    getLintelDownByRecord({ rootState }, id) { // 获取楣板own表 修改记录
        return new Promise((resolve, reject) => {
            axios.get(`${config.api.reqApi}/api/LintelDown/GetRecord?joinId=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    }, 
    editLintelDownAudit({ rootState }, opt) { // 修改楣板
        return new Promise((resolve, reject) => {
            axios.put(`${config.api.reqApi}/api/LintelDown/Verify`, opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err.response.data);
            });
        });
    },   
 
 

    getVehicleDownById({ rootState }, id) { // 获取车证own表 修改记录
        return new Promise((resolve, reject) => {
            axios.get(`${config.api.reqApi}/api/VehicleDown?id=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    getVehicleDownByRecord({ rootState }, id) { // 获取车证own表 修改记录
        return new Promise((resolve, reject) => {
            axios.get(`${config.api.reqApi}/api/VehicleDown/GetListRecordByJoinId?joinId=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    }, 
    editVehicleDownAudit({ rootState }, opt) { // 修改车证
        return new Promise((resolve, reject) => {
            axios.put(`${config.api.reqApi}/api/VehicleDown/Verify`, opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err.response.data);
            });
        });
    },   
 

    // 动态模块
    getNews({ rootState }, opt) { // 获取动态
        return new Promise((resolve, reject) => {
            axios.post(`${config.api.reqApi}/api/NewsExhibitor/All?show=${opt.show}`, opt.value, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    getExNewsById({ rootState }, id) { // 获取动态
        return new Promise((resolve, reject) => {
            axios.get(`${config.api.reqApi}/api/NewsExhibitor?id=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    auditNews({ rootState }, opt) { // 审核动态
        return new Promise((resolve, reject) => {
            axios.put(`${config.api.reqApi}/api/NewsExhibitor/Audit`, opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    addHostNews({ rootState }, opt) { // 主办 - 添加动态
        return new Promise((resolve, reject) => {
            axios.post(`${config.api.reqApi}/api/NewsHost`, opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    editHostNews({ rootState }, opt) { // 主办 - 编辑动态
        return new Promise((resolve, reject) => {
            axios.put(`${config.api.reqApi}/api/NewsHost`, opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    getHostNews({ rootState }, opt) { // 主办 - 获取动态
        return new Promise((resolve, reject) => {
            axios.post(`${config.api.reqApi}/api/NewsHost/All`, opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    getHostNewsById({ rootState }, id) { // 主办 - 根据Id获取动态
        return new Promise((resolve, reject) => {
            axios.get(`${config.api.reqApi}/api/NewsHost?id=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    delHostNews({ rootState }, id) { // 主办 - 删除动态
        return new Promise((resolve, reject) => {
            axios.delete(`${config.api.reqApi}/api/NewsHost?id=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    setNews({ rootState }, opt) { // 修改动态显示/隐藏
        return new Promise((resolve, reject) => {
            axios.put(`${config.api.reqApi}/api/NewsExhibitor/SetShow`, opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    delExNews({ rootState }, id) { // 删除展商动态
        return new Promise((resolve, reject) => {
            axios.delete(`${config.api.reqApi}/api/NewsExhibitor?id=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    getIsCar({ rootState }, id) {
        return new Promise((resolve, reject) => {
            axios.get(`${config.api.reqApi}/api/VehicleDown/GetHasRecord?joinId=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
} 